var _style, _g, _g2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgContributionStep3 = function SvgContributionStep3(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "contribution-step-3_svg__\\u56FE\\u5C42_1",
    xmlns: "http://www.w3.org/2000/svg",
    x: 0,
    y: 0,
    viewBox: "0 0 46.3 44",
    style: {
      enableBackground: "new 0 0 46.3 44"
    },
    xmlSpace: "preserve"
  }, props), _style || (_style = /*#__PURE__*/React.createElement("style", null, ".contribution-step-3_svg__st1{fill:#172d72}.contribution-step-3_svg__st2{fill:#be1d32}")), /*#__PURE__*/React.createElement("g", {
    id: "contribution-step-3_svg__\\u7EC4_5631",
    transform: "translate(-765.052 -138.422)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "contribution-step-3_svg__\\u77E9\\u5F62_4561",
    style: {
      fill: "#e8eaf1"
    },
    d: "M765.1 138.4h35v40h-35z"
  }), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "contribution-step-3_svg__\\u7EC4_5632",
    transform: "translate(782.672 153.84)"
  }, /*#__PURE__*/React.createElement("ellipse", {
    id: "contribution-step-3_svg__\\u692D\\u5706_1281",
    className: "contribution-step-3_svg__st1",
    cx: 4.4,
    cy: 24.1,
    rx: 4,
    ry: 4.5
  }), /*#__PURE__*/React.createElement("path", {
    id: "contribution-step-3_svg__\\u77E9\\u5F62_4562",
    transform: "rotate(-45.001 17.675 10.979)",
    className: "contribution-step-3_svg__st1",
    d: "M5.2 8h25v6h-25z"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "contribution-step-3_svg__\\u7EC4_5633",
    transform: "translate(769.479 147.204)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "contribution-step-3_svg__\\u77E9\\u5F62_4563",
    className: "contribution-step-3_svg__st2",
    d: "M0 0h22v4.4H0z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "contribution-step-3_svg__\\u77E9\\u5F62_4564",
    className: "contribution-step-3_svg__st2",
    d: "M0 8.9h13.2v4.4H0z"
  })))));
};
export default SvgContributionStep3;